export default "__VITE_ASSET__c84fd86b__"